import script from "./TextColorButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextColorButton.vue?vue&type=script&lang=ts&setup=true"

import "./TextColorButton.vue?vue&type=style&index=0&id=37449800&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37449800"]])

export default __exports__